import { render, staticRenderFns } from "./EcommerceCheckout.vue?vue&type=template&id=436b52f9&scoped=true"
import script from "./EcommerceCheckout.vue?vue&type=script&lang=js"
export * from "./EcommerceCheckout.vue?vue&type=script&lang=js"
import style0 from "./EcommerceCheckout.vue?vue&type=style&index=0&id=436b52f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b52f9",
  null
  
)

export default component.exports